
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import ServicesPage from '../pages/services/page';
import AboutPage from '../pages/about/page';
import ContactPage from '../pages/contact/page';
import ReviewsPage from '../pages/reviews/page';
import DirectionsPage from '../pages/directions/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/reviews',
    element: <ReviewsPage />,
  },
  {
    path: '/directions',
    element: <DirectionsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
